import { useSegment } from '@telialt/utils/src/segment';

import { ESHOP_MUTATION_KEY } from '../../model';
import { apiCreateCart } from '../../store/api';
import { useMutationWithCartRefresh } from './useMutationWithCartRefresh';

export const useForceCreateCart = () => {
    const segment = useSegment();

    const mutation = useMutationWithCartRefresh(async () => (await apiCreateCart(segment)).data, {
        mutationKey: [ESHOP_MUTATION_KEY.FORCE_CREATE_CART],
    });

    return {
        forceCreateCart: () => mutation.mutate(),
        isLoadingForceCreateCart: mutation.isPending,
        isErrorForceCreateCart: mutation.isError,
        errorForceCreateCart: mutation.error,
        statusForceCreateCart: mutation.status,
    };
};
